module.exports = __webpack_public_path__ + "img/webz.e42eb7d5.svg";